/* ============================================================
   VAULT — theme scripts
   ・固定ヘッダー高さの計測（--v-header-h）
   ・Hero スライダー
   ・ナビのドロップダウン / モバイルドロワー
   ・PDP ギャラリー / 数量 / アコーディオン / アドオン同時カート投入
   ============================================================ */
(function () {
  'use strict';

  var docEl = document.documentElement;

  /* ---------- 固定ヘッダーの実高をCSS変数へ ---------- */
  function measureHeader() {
    var bar = document.querySelector('.v-topbar');
    var h = bar ? bar.offsetHeight : 100;
    docEl.style.setProperty('--v-header-h', h + 'px');
  }

  /* ---------- ヘッダー：スクロールで背景を濃くする ---------- */
  function initHeaderScroll() {
    var nav = document.querySelector('.v-nav');
    if (!nav) return;
    var onScroll = function () {
      nav.classList.toggle('v-nav--solid', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- ナビ：ドロップダウン（クリック／キーボード対応） ---------- */
  function initDropdowns(root) {
    (root || document).querySelectorAll('[data-v-dropdown]').forEach(function (li) {
      var trigger = li.querySelector('[data-v-dropdown-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        if (trigger.tagName === 'A' && window.matchMedia('(min-width: 901px)').matches) return;
        e.preventDefault();
        var open = li.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          li.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
    document.addEventListener('click', function (e) {
      document.querySelectorAll('[data-v-dropdown].is-open').forEach(function (li) {
        if (!li.contains(e.target)) {
          li.classList.remove('is-open');
          var t = li.querySelector('[data-v-dropdown-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ---------- モバイルドロワー ---------- */
  function initMobileDrawer() {
    var drawer = document.querySelector('[data-v-mdrawer]');
    if (!drawer) return;
    var open = function () {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var c = drawer.querySelector('.v-mdrawer__close');
      if (c) c.focus();
    };
    var close = function () {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    };
    document.querySelectorAll('[data-v-mdrawer-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    drawer.querySelectorAll('[data-v-mdrawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    drawer.querySelectorAll('[data-v-msub-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = btn.parentElement.parentElement.querySelector('.v-mnav__sub');
        if (!sub) return;
        var isOpen = sub.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  /* ---------- Hero スライダー ---------- */
  function initHero(section) {
    var hero = section
      ? section.querySelector('[data-v-hero]')
      : document.querySelector('[data-v-hero]');
    if (!hero) return;
    var slides = hero.querySelectorAll('[data-v-hero-slide]');
    var copies = hero.querySelectorAll('[data-v-hero-copy]');
    var dots = hero.querySelectorAll('[data-v-hero-dot]');
    var counter = hero.querySelector('[data-v-hero-count]');
    var total = slides.length;
    if (total === 0) return;
    var idx = 0;
    var timer = null;
    var interval = parseInt(hero.getAttribute('data-autoplay') || '0', 10);

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function show(i) {
      idx = (i + total) % total;
      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === idx);
      });
      copies.forEach(function (c, n) {
        c.classList.remove('is-active');
        if (n === idx) {
          void c.offsetWidth; /* アニメーションを再生させるためのリフロー */
          c.classList.add('is-active');
        }
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === idx);
        d.setAttribute('aria-current', n === idx ? 'true' : 'false');
      });
      if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(total);
    }

    function play() {
      if (!interval || total < 2) return;
      stop();
      timer = setInterval(function () {
        show(idx + 1);
      }, interval);
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    hero.querySelectorAll('[data-v-hero-prev]').forEach(function (b) {
      b.addEventListener('click', function () {
        show(idx - 1);
        play();
      });
    });
    hero.querySelectorAll('[data-v-hero-next]').forEach(function (b) {
      b.addEventListener('click', function () {
        show(idx + 1);
        play();
      });
    });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () {
        show(n);
        play();
      });
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);

    show(0);
    play();
  }

  /* ---------- PDP ギャラリー ---------- */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-v-gallery]').forEach(function (gal) {
      var slides = gal.querySelectorAll('[data-v-gal-slide]');
      var thumbs = gal.querySelectorAll('[data-v-gal-thumb]');
      if (slides.length === 0) return;
      var i = 0;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.classList.toggle('is-active', k === i);
        });
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
      }
      thumbs.forEach(function (t, k) {
        t.addEventListener('click', function () {
          show(k);
        });
      });
      var prev = gal.querySelector('[data-v-gal-prev]');
      var next = gal.querySelector('[data-v-gal-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); });
      if (next) next.addEventListener('click', function () { show(i + 1); });
      /* バリアント切替時に該当画像へジャンプ */
      gal.addEventListener('v:variant-image', function (e) {
        var mediaId = e.detail && e.detail.mediaId;
        if (!mediaId) return;
        slides.forEach(function (s, k) {
          if (s.getAttribute('data-media-id') === String(mediaId)) show(k);
        });
      });
      show(0);
    });
  }

  /* ---------- 数量ステッパー ---------- */
  function initQty(scope) {
    (scope || document).querySelectorAll('[data-v-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      if (!input) return;
      wrap.querySelectorAll('[data-v-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-v-qty-step'), 10) || 1;
          var min = parseInt(input.getAttribute('min') || '1', 10);
          var next = (parseInt(input.value, 10) || min) + step;
          if (next < min) next = min;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- アコーディオン ---------- */
  function initAccordions(scope) {
    (scope || document).querySelectorAll('[data-v-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- バリアント選択（ピル → 実際のvariant切替） ---------- */
  function initVariantPicker(scope) {
    (scope || document).querySelectorAll('[data-v-variant-form]').forEach(function (form) {
      var json = form.querySelector('[data-v-variant-json]');
      if (!json) return;
      var variants;
      try {
        variants = JSON.parse(json.textContent);
      } catch (err) {
        return;
      }
      var idInput = form.querySelector('[data-v-variant-id]');
      var priceEl = document.querySelector('[data-v-price]');
      var compareEl = document.querySelector('[data-v-compare]');
      var atc = form.querySelector('[data-v-atc]');
      var gallery = document.querySelector('[data-v-gallery]');
      var radios = form.querySelectorAll('input[data-option-position]');
      if (radios.length === 0) return;

      function selectedOptions() {
        var out = [];
        radios.forEach(function (r) {
          if (r.checked) out[parseInt(r.getAttribute('data-option-position'), 10) - 1] = r.value;
        });
        return out;
      }

      function update() {
        var sel = selectedOptions();
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var k = 0; k < sel.length; k++) {
            if (variants[i].options[k] !== sel[k]) { ok = false; break; }
          }
          if (ok) { match = variants[i]; break; }
        }

        /* ピルの見た目とラベル */
        radios.forEach(function (r) {
          var pill = r.closest('[data-v-option-pill]');
          if (pill) pill.classList.toggle('is-active', r.checked);
        });
        sel.forEach(function (val, k) {
          var label = form.querySelector('[data-v-option-label="' + (k + 1) + '"]');
          if (label) label.textContent = val;
        });

        if (!match) {
          if (atc) { atc.disabled = true; atc.textContent = '選択できない組み合わせです'; }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.innerHTML = match.price;
        if (compareEl) {
          if (match.compare_at_price) {
            compareEl.innerHTML = match.compare_at_price;
            compareEl.hidden = false;
          } else {
            compareEl.innerHTML = '';
            compareEl.hidden = true;
          }
        }
        if (atc) {
          atc.disabled = !match.available;
          atc.textContent = match.available
            ? atc.getAttribute('data-label-add') || atc.textContent
            : atc.getAttribute('data-label-soldout') || 'SOLD OUT';
        }
        if (gallery && match.media_id) {
          gallery.dispatchEvent(new CustomEvent('v:variant-image', { detail: { mediaId: match.media_id } }));
        }
        /* URLに ?variant= を反映（履歴を汚さないよう置換） */
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        }
      }

      radios.forEach(function (r) {
        r.addEventListener('change', update);
      });
      if (atc && !atc.getAttribute('data-label-add')) {
        atc.setAttribute('data-label-add', atc.textContent.trim());
      }
    });
  }

  /* ---------- 自動レコメンドの読み込み ---------- */
  function initRecs(scope) {
    (scope || document).querySelectorAll('[data-v-recs]').forEach(function (box) {
      var url = box.getAttribute('data-url');
      if (!url || box.getAttribute('data-loaded') === '1') return;
      box.setAttribute('data-loaded', '1');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-v-recs]');
          if (fresh && fresh.innerHTML.trim() !== '') {
            box.innerHTML = fresh.innerHTML;
          } else {
            var sec = box.closest('.shopify-section');
            if (sec) sec.hidden = true;
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- アドオン（ケース）同時カート投入 ---------- */
  function initAddon(scope) {
    (scope || document).querySelectorAll('[data-v-addon-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var box = form.querySelector('[data-v-addon-check]');
        if (!box || !box.checked) return; /* チェックなしなら通常の1点購入 */
        var addonId = form.querySelector('[data-v-addon-variant]');
        var mainId = form.querySelector('[name="id"]');
        if (!addonId || !addonId.value || !mainId) return;
        e.preventDefault();
        var qtyEl = form.querySelector('[name="quantity"]');
        var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        var btn = form.querySelector('.v-atc');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = '追加中…'; }
        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(mainId.value), quantity: qty },
              { id: Number(addonId.value), quantity: qty }
            ]
          })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            window.location.href = window.routes.cart_url;
          })
          .catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            window.alert('カートに追加できませんでした。もう一度お試しください。');
          });
      });
    });
  }

  function initAll(scope) {
    measureHeader();
    initHeaderScroll();
    initDropdowns(scope);
    initMobileDrawer();
    initHero(scope);
    initGallery(scope);
    initQty(scope);
    initAccordions(scope);
    initVariantPicker(scope);
    initAddon(scope);
    initRecs(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  window.addEventListener('resize', measureHeader);
  window.addEventListener('load', measureHeader);

  /* テーマエディターでのセクション再読込に対応 */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', measureHeader);
})();
